export enum SECTION_TITLES {
    AllCompanies = "companies",
    SelectedCompanies = "selected companies",
    OtherCompanies = "other companies"
}
